import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const subtitle = "Love in Faith Success Stories";
const title = "Sweet Stories From Our Lovers";

// Fallback images
const fallbackImages = [
  "assets/images/story/04.jpg",
  "assets/images/story/05.jpg",
  "assets/images/story/06.jpg",
];

// Helper to get post image or fallback
const getImageUrl = (imgUrl) => {
  return (
    imgUrl ?? fallbackImages[Math.floor(Math.random() * fallbackImages.length)]
  );
};

const StorySection = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_MAIN_SITE_URL}/homepage-posts`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        setPosts(res.data.data.posts);
      } catch (err) {
        console.error("Failed to fetch homepage posts", err);
      }
    };

    fetchPosts();
  }, []);

  return (
    <section className="story-section padding-tb bg-img">
      <div className="container">
        <div className="section-header">
          <h4>{subtitle}</h4>
          <h2>{title}</h2>
        </div>
        <div className="section-wrapper">
          <div className="row justify-content-center g-4">
            {posts.map((post, i) => (
              <div className="col-lg-4 col-md-6 col-12" key={i}>
                <div className="story-item lab-item">
                  <div className="lab-inner">
                    <div
                      className="lab-thumb"
                      style={{
                        height: "250px",
                        overflow: "hidden",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#00000010",
                      }}
                    >
                      <img
                        src={getImageUrl(post.imgUrl)}
                        alt="post"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                          display: "block",
                        }}
                      />
                    </div>
                    <div className="lab-content">
                      <h4>{post.title ?? "Unknown"}</h4>
                      <p>{post.desc}</p>
                      <Link to="/post" className="lab-btn">
                        <i className="icofont-circled-right"></i> Read More
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default StorySection;
